import { LifestyleCompletePageTemplate } from "./template";
import { useLifestyleCompletePage } from "./logic";

export const LifestyleCompletePage = () : JSX.Element => {
    const props = useLifestyleCompletePage();

    return (
        <LifestyleCompletePageTemplate {...props}/>
    )
} 